import React from "react";
import "./style.scss";

const NoQuiz = (props) => {
  return (
    <>
      <div className="detail-noquiz text-center">
        <span className="noquiz-title">
          There is no {props.title == "survey" ? "survey" : "quiz"}
        </span>
        <div className="noquiz-image">
          <img
            src={`${process.env.PUBLIC_URL + "/SKOR-Quiz-NoQuiz.png"}`}
            alt="logo_image"
          />
        </div>
        <span className="noquiz-desc">
          Stay tuned for more {props.title == "survey" ? "survey" : "quizzes"}.
        </span>
      </div>
    </>
  );
};

export default NoQuiz;
